import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

export default function SearchButton({ open, onClick }) {
  return <IconButton onClick={onClick}>{open ? <CloseIcon /> : <SearchIcon />}</IconButton>;
}
